//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CDoubleButton',

  props: {
    leftText: {
      type: String,
      default: '取消',
    },

    rightText: {
      type: String,
      default: '确定',
    },

    leftClick: {
      type: Function,
      default: () => () => {},
    },

    rightClick: {
      type: Function,
      default: () => () => {},
    },

    rightDisabled: {
      type: Boolean,
      default: false,
    },

    leftDisabled: {
      type: Boolean,
      default: false,
    },
  },
}
